//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/ScCollector.js";
import "../GeometricUtilities/GeometricUtilities.ProjectionOptions.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
let d=[[[1,"DepthDimension",0,"Expression",0],[0,"DepthMethod",1,0],[1,"Length1",0,"Expression",0],[1,"Length2",0,"Expression",0],[1,"LengthDimension",0,"Expression",0],[0,"LengthMethod",1,0],[1,"LimitCurve1",0,"Section",0],[1,"LimitCurve2",0,"Section",0],[1,"LimitFace1",0,"ScCollector",0],[1,"LimitFace2",0,"ScCollector",0],[0,"LimitPlane1",1,"Plane",0],[0,"LimitPlane2",1,"Plane",0],[0,"LimitPoint1",1,"Point",0],[0,"LimitPoint2",1,"Point",0],[0,"LoopDirection",1,0],[1,"OffsetDimension",0,"Expression",0],[1,"ProjectionDir1",0,"GeometricUtilities.ProjectionOptions",0],[1,"ProjectionDir2",0,"GeometricUtilities.ProjectionOptions",0],[1,"RampLength1",0,"Expression",0],[1,"RampLength2",0,"Expression",0],[0,"RefType1",1,0],[0,"RefType2",1,0],[0,"ReverseDepthDirection",1,0],[0,"ReverseWidthDirection",1,0],[1,"Selectface",0,"ScCollector",0],[1,"ShelfEdge",0,"ScCollector",0],[0,"ShelfEnd",1,0],[0,"ShelfType",1,1],[0,"StepMethod1",1,0],[0,"StepMethod2",1,0],[0,"Swap",1,0],[0,"Type",1,0],[1,"WidthDimension",0,"Expression",0]],[],[]];
SPLM.Features.ShelfBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShelfBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShelfBuilder.Types = Object.freeze({
    "End" : "End", "Middle" : "Middle"});

SPLM.Features.ShelfBuilder.LengthMethods = Object.freeze({
    "Full" : "Full", "ShelfFromEnd" : "ShelfFromEnd", "StepFromEnd" : "StepFromEnd", "ToSelected" : "ToSelected"});

SPLM.Features.ShelfBuilder.ReferenceType = Object.freeze({
    "Face" : "Face", "DatumPlane" : "DatumPlane", "Curve" : "Curve", "Point" : "Point"});

SPLM.Features.ShelfBuilder.StepMethod = Object.freeze({
    "Normal" : "Normal", "AlignwithReferenceFace" : "AlignwithReferenceFace", "Ramp" : "Ramp"});

SPLM.Features.ShelfBuilder.DepthMethods = Object.freeze({
    "Offset" : "Offset", "ToNextWall" : "ToNextWall"});

export default SPLM;